/**
 * Photo Checklist Question Component
 *
 * This file contains a React component called PhotoChecklistQuestion that represents an individual 
 * photo checklist item. It handles the adding and removing of points when a photo is attached 
 * to this particular item. The component receives props such as question, checked, photo, and updatePoints. 
 * It renders a PhotoSelectModal component that allows the user to select a photo and updates the 
 * state accordingly. Any team member may select a photo while the hunt is active. The component is 
 * exported as the default export and has PropTypes defined for its props.
 */

import React from 'react'
import PropTypes from 'prop-types'
import PhotoSelectModal from '../photos/photo-select-modal'
import { getHuntStatus } from '../../utils/team-data'

class PhotoChecklistQuestion extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      checked: props.checked,
      photo: props.photo ?? null,
    }
    this.handleSelect = this.handleSelect.bind(this)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.checked !== this.props.checked || prevProps.photo !== this.props.photo) {
      this.setState({
        checked: this.props.checked,
        photo: this.props.photo ?? null,
      })
    }
  }

  handleSelect(photo) {
    const { question, updatePoints } = this.props
    const points = question.answer_value ? question.answer_value : 5
    if (photo !== null && photo !== undefined) {
      this.setState({
        checked: true,
        photo: photo,
      })
      updatePoints(points, { id: question.id, checked: true, photo: photo, points: points })
    } else {
      this.setState({
        checked: false,
        photo: null,
      })
      updatePoints(-points, { id: question.id, checked: false, photo: null, points: points })
    }
  }

  render() {
    const { question } = this.props
    const { photo } = this.state
    const huntStatus = getHuntStatus()
    const canSelect = huntStatus !== `ended`
    let buttonText = `Choose Photo`
    if (photo) {
      buttonText = `Change Photo`
    }
    return (
      <div className="checklist-item-wrapper">
        <div className="photo-checklist-question mb-3 row no-gutters">
          <div className="col-4 text-center">
            <PhotoSelectModal
              selectedPhoto={photo}
              description={question.description}
              buttonText={buttonText}
              canSelect={canSelect}
              submitOnSelect
              onSelect={this.handleSelect}
            />
          </div>
          <div className={`col-8`}>
            <div className="photo-heading px-3 py-3 text-right header-data">{question.answer_value} pts</div>
            <div className="py-3 px-3" dangerouslySetInnerHTML={{ __html: question.description }} />
          </div>
        </div>
      </div>
    )
  }
}

export default PhotoChecklistQuestion

PhotoChecklistQuestion.propTypes = {
  question: PropTypes.object.isRequired,
  checked: PropTypes.bool.isRequired,
  photo: PropTypes.object,
  updatePoints: PropTypes.func.isRequired,
}
